import { gql } from "../../../__generated__";

export const GET_STAGES = gql(`
query stages {
  stages {
    id
    name
  }
}
`);